import React from "react";
import { Modal } from "antd";
import { $t } from "~/i18n.js";
import { getBadgeConfig, showHighestBadgePerLevel } from "./BadgeConfig.js";
import { StackedBadge } from "./BadgeLevels.jsx";
import { playCelebrate } from "~/lib/speech.js";

const BadgeNotificationContent = ({ badges }) => {
  const badgeConfig = getBadgeConfig();
  badges = showHighestBadgePerLevel(badges);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}
    >
      {badges.map((b) => {
        const config = badgeConfig[b.name];
        return (
          <div
            key={b.name}
            style={{ display: "flex", alignItems: "center", gap: 10 }}
          >
            <StackedBadge
              icon={config?.icon}
              label={config?.label || b.name}
              count={b.level || 1}
              earned
              size={28}
              step={4}
            />
            <div>
              <div style={{ fontWeight: 500, fontSize: 13 }}>
                {config?.label || b.name}
              </div>
              <div
                style={{ fontSize: 11, color: "#888" }}
              >{`${$t("Level")} ${b.level || 1}`}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const showBadgeNotificationModal = (badges) => {
  if (!badges?.length) return;

  // TODO debug badges
  if (localStorage.getItem("badges") !== "true") return

  const userName = badges[0].user_name;

  // play sound
  playCelebrate()
  
  Modal.success({
    title: userName
      ? $t("Badge behaald, ${name}!", { name: userName })
      : $t("Badge behaald!"),
    content: React.createElement(BadgeNotificationContent, { badges }),
  });
};
